module.exports = __webpack_public_path__ + "static/media/results.6b53685d.svg";